import { cn } from '@ui-kit/utils';
import type { ComponentProps } from 'react';
import CheckIcon from '@/components/icons/CheckIcon';

const Li = ({
  checkmarkColor = 'default',
  iconSize = 'lg',
  className,
  children,
  ...props
}: ComponentProps<'li'> & { checkmarkColor?: 'brand' | 'default'; iconSize?: 'sm' | 'lg' }) => (
  <li className={cn('flex items-start gap-2', className)} {...props}>
    <CheckIcon
      aria-hidden="true"
      className={cn(
        iconSize === 'sm' ? 'mt-0.75 size-4' : 'size-6', // adding 3px to align the icon with the text due to line height
        checkmarkColor === 'brand' ? 'text-icon-brand' : 'text-icon-default',
      )}
    />
    <span>{children}</span>
  </li>
);

const CheckmarkList = ({ gap = 'lg', className, ...props }: ComponentProps<'ul'> & { gap?: 'sm' | 'lg' }) => (
  <ul
    className={cn('m-0 flex list-none flex-col pl-0', gap === 'sm' ? 'gap-2' : 'gap-4', className)}
    {...props}
  />
);

CheckmarkList.Item = Li;

export default CheckmarkList;
